module.exports = __webpack_public_path__ + "img/81600.b2ca9031.jpg";